import React from 'react'

import { isNorthstarBrand } from '@pb/utils'

import OPTIMIZELY from 'constants/optimizely'
import ClubCard from 'features/account/club-card'
import useAccountFeature from 'features/account/hooks/useAccountFeature'
import useOptimizelyDecision from 'features/account/hooks/useOptimizelyDecision'
import useOptimizelyToggle from 'features/account/hooks/useOptimizelyToggle'
import { MyRewardsList } from 'features/account/my-rewards'
import NewMemberCard from 'features/account/new-member-card/NewMemberCard'
import NewMemberCardNS from 'features/account/new-member-card/NewMemberCardNS'
import News from 'features/account/news'
import ActivePurchasesOverview from 'features/account/purchases/components/ActivePurchasesOverview'
import RecentlyViewed from 'features/account/recently-viewed/index'
import { UserMenu } from 'features/account/user-menu'

const MobileFullMember: React.FC = () => {
  const {
    pages: {
      hub: { shouldShowClubCard, shouldShowRewards, shouldShowNewsWidget },
    },
  } = useAccountFeature()

  const hideOrderStatusWidget = useOptimizelyToggle({
    key: OPTIMIZELY.ACCOUNT_HIDE_ORDER_STATUS_WIDGET,
  })
  /**
   * Only for A/B testing purposes
   * TODO: remove when iterative testing of component is completed.
   * https://hmgroup.atlassian.net/browse/CRMMA-5370
   */
  const isRecentlyViewedEnabled = useOptimizelyToggle({
    key: OPTIMIZELY.ACCOUNT_RECENTLY_VIEWED,
  })

  const isNewMemberCardEnabled = useOptimizelyToggle({
    key: OPTIMIZELY.ACCOUNT_NEW_MEMBER_CARD,
  })

  const shouldShowNorthstarVariant = useOptimizelyDecision(OPTIMIZELY.ACCOUNT_NORTHSTAR_VARIATION)

  return (
    <main id="main-content">
      {shouldShowClubCard && (
        <>
          {isNorthstarBrand ? (
            shouldShowNorthstarVariant ? (
              <NewMemberCardNS />
            ) : (
              <ClubCard />
            )
          ) : (
            <>{isNewMemberCardEnabled ? <NewMemberCard /> : <ClubCard />}</>
          )}
        </>
      )}
      {!hideOrderStatusWidget && <ActivePurchasesOverview />}
      {shouldShowRewards && <MyRewardsList />}
      {shouldShowNewsWidget && <News />}
      <UserMenu />
      {isRecentlyViewedEnabled && <RecentlyViewed />}
    </main>
  )
}

export default MobileFullMember
